import ApiService from "@/common/api.service";

export default {
	getTemplateMethodVariables(zone_id) {
		return ApiService.query(`authentication/template-method-variables?zone_id=${zone_id}`);
	}
}